export enum NumberFormatType {
	None = 'none',
	CommaSeparated = 'comma',
	Compact = 'compact',
	Percent = 'percent',
	Custom = 'custom',
}

export type Delimiter = 'comma' | 'dot' | 'space';

export type UnitPosition = 'before' | 'after';

export type NumberFormatConfig =
	| {
			type: NumberFormatType.None;
	  }
	| {
			type: NumberFormatType.CommaSeparated;
	  }
	| {
			type: NumberFormatType.Compact;
	  }
	| {
			type: NumberFormatType.Percent;
	  }
	| {
			type: NumberFormatType.Custom;
			delimiter: Delimiter;
			unit: string;
			unitPosition: UnitPosition;
			precision: string;
			compact: boolean;
	  };

export function createDefaultConfig(type: NumberFormatType): NumberFormatConfig {
	switch (type) {
		case NumberFormatType.None:
			return {
				type: NumberFormatType.None,
			};

		case NumberFormatType.Compact:
			return {
				type: NumberFormatType.Compact,
			};

		case NumberFormatType.Percent:
			return {
				type: NumberFormatType.Percent,
			};

		case NumberFormatType.CommaSeparated:
			return {
				type: NumberFormatType.CommaSeparated,
			};

		case NumberFormatType.Custom:
			return {
				type: NumberFormatType.Custom,
				delimiter: 'comma',
				precision: '2',
				unit: '',
				unitPosition: 'before',
				compact: false,
			};

		default:
			throw new Error(`Unknown number format type: ${type}`);
	}
}
